import { createSlice } from "@reduxjs/toolkit";
import { Template } from "../../@types/template";
import { TemplateQuestion } from "../../@types/templateQuestion";
import { createAllAutomatticDocuments } from "./actions/createAllAutomatticDocuments";
import { findAutomatticTemplates} from "./actions/findAutomatticTemplates";
import { findTemplateName } from "./actions/findTemplateName";
import { findUserRoleCode } from "./actions/findUserRoleCode";
import { findUserTemplateList } from "./actions/findUserTemplateList";

interface UserTemplateState {
    userTemplateList: Template[];
    userTemplateListStatus: "idle" | "pending" | "succeeded" | "failed";
    templateName: string;
    findTemplateNameStatus: "idle" | "pending" | "succeeded" | "failed";
    automatticTemplates: TemplateQuestion[];
    findAutomatticTemplates: "idle" | "pending" | "succeeded" | "failed";
    userRoleCode: string,
    findUserRoleCodeStatus: "idle" | "pending" | "succeeded" | "failed";
    createAllAutomatticDocumentsStatus: "idle" | "pending" | "succeeded" | "failed";
}

const initialState = {
    userTemplateList: [],
    userTemplateListStatus: "idle",
    templateName: "",
    findTemplateNameStatus: "idle",
    automatticTemplates: [],
    findAutomatticTemplates: "idle",
    userRoleCode: "",
    findUserRoleCodeStatus: "idle",
    createAllAutomatticDocumentsStatus: "idle",
} as UserTemplateState;

const userTemplateSlice = createSlice({
    name: "userTemplate",
    initialState,
    reducers: {
        initCreateAllAutomatticDocumentsStatus(state){
            state.createAllAutomatticDocumentsStatus = "idle";
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(findUserTemplateList.pending, (state) => {
                state.userTemplateListStatus = "pending";
            })
            .addCase(findUserTemplateList.fulfilled, (state, { payload }) => {
                state.userTemplateList = payload;
                state.userTemplateListStatus = "succeeded";
            })
            .addCase(findUserTemplateList.rejected, (state, { payload }) => {
                state.userTemplateList = [];
                state.userTemplateListStatus = "failed";
            })
            .addCase(findTemplateName.pending, (state) => {
                state.templateName = "";
                state.findTemplateNameStatus = "pending";
            })
            .addCase(findTemplateName.rejected, (state) => {
                state.templateName = "";
                state.findTemplateNameStatus = "failed";
            })
            .addCase(findTemplateName.fulfilled, (state, { payload }) => {
                state.templateName = payload;
                state.findTemplateNameStatus = "succeeded";
            })
            .addCase(findAutomatticTemplates.pending, (state) => {
                state.automatticTemplates = [];
                state.findAutomatticTemplates = "pending";
            })
            .addCase(findAutomatticTemplates.rejected, (state) => {
                state.automatticTemplates = [];
                state.findAutomatticTemplates = "failed";
            })
            .addCase(findAutomatticTemplates.fulfilled, (state, { payload }) => {
                state.automatticTemplates= payload;
                state.findAutomatticTemplates = "succeeded";
            })
            .addCase(findUserRoleCode.pending, (state) => {
                state.userRoleCode = "";
                state.findUserRoleCodeStatus = "pending";
            })
            .addCase(findUserRoleCode.rejected, (state) => {
                state.userRoleCode = "";
                state.findUserRoleCodeStatus = "failed";
            })
            .addCase(findUserRoleCode.fulfilled, (state, { payload }) => {
                state.userRoleCode = payload
                state.findUserRoleCodeStatus = "succeeded";
            })
            .addCase(createAllAutomatticDocuments.pending, (state) => {
                state.createAllAutomatticDocumentsStatus = "pending";
            })
            .addCase(createAllAutomatticDocuments.rejected, (state) => {
                state.createAllAutomatticDocumentsStatus = "failed";
            })
            .addCase(createAllAutomatticDocuments.fulfilled, (state) => {
                state.createAllAutomatticDocumentsStatus = "succeeded";
            })
            ;
    },
});

export const {
    initCreateAllAutomatticDocumentsStatus,
  } = userTemplateSlice.actions

export default userTemplateSlice.reducer;
